// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3xXLg","dragIcon":"SortableItem_dragIcon__2vyNO","disabled":"SortableItem_disabled__1STPJ"};